import { PrimaryNav, NavRight } from "@/components/AppNav";

export function StickyNav({ sections }) {
  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/75 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 h-14">
          <nav className="flex-1 flex items-center overflow-x-auto no-scrollbar">
            <PrimaryNav sections={sections} onSectionClick={go} />
          </nav>
          <NavRight />
        </div>
      </div>
    </header>
  );
}
